export default __webpack_public_path__ + "static/media/more-circle.7c59ed21.svg";